import {
  Tooltip,
  TooltipProps,
  Typography,
  TypographyProps
} from '@mui/material'
import React from 'react'

export const TruncatedTextWithTooltip: React.FC<
  Omit<TypographyProps, 'children'> & {
    children: React.ReactNode
    tooltipProps?: Omit<TooltipProps, 'children'>
  }
> = ({ children, tooltipProps, ...rest }) => {
  return (
    <Tooltip arrow placement="top" {...tooltipProps}>
      <Typography noWrap {...rest}>
        {children}
      </Typography>
    </Tooltip>
  )
}
